import React from 'react';
import './Logo.css';

import logoImage from '../../assets/logos.png';
import whitelogoImage from '../../assets/white-logo.png';

const Logo = ({
  width = '100px',
  height = '100px',
  color = 'blue'
}) => {
  const logo = color === 'white' ? whitelogoImage : logoImage;

  return (
    <img
      src={logo}
      alt="Logo"
      style={{
        width,
        height,
        objectFit: 'contain'
      }}
    />
  );
};

export default Logo;